import type { AppRouter } from '@alison/api/router';
import { type UseQueryResult, useQuery } from '@tanstack/react-query';
import type { TRPCClientErrorLike } from '@trpc/client';
import type { inferOutput } from '@trpc/tanstack-react-query';
import { useTRPC } from './trpc';

type QueryResult<TData> = UseQueryResult<TData, TRPCClientErrorLike<AppRouter>>;
export type LeadingKpiOptions = inferOutput<
  ReturnType<typeof useTRPC>['filters']['leadingKpiOptions']
>;
export type LeadingKpiCoverage = inferOutput<
  ReturnType<typeof useTRPC>['filters']['leadingKpiCoverage']
>;

export function useLeadingKpiOptions(accountIds?: number[]): QueryResult<LeadingKpiOptions> {
  const trpc = useTRPC();
  return useQuery(
    trpc.filters.leadingKpiOptions.queryOptions(accountIds ? { accountIds } : undefined),
  );
}

export function useLeadingKpiCoverage(
  leadingKpi: string,
  accountIds: number[],
): QueryResult<LeadingKpiCoverage> {
  const trpc = useTRPC();
  return useQuery({
    ...trpc.filters.leadingKpiCoverage.queryOptions({ leadingKpi, accountIds }),
    enabled: accountIds.length > 0,
  });
}
